// extracted by mini-css-extract-plugin
export default {"root":"Collapse_root__zt+w-","active":"Collapse_active__A9owh","highlighted":"Collapse_highlighted__euqkB"};